import { yupResolver } from "@hookform/resolvers/yup";
import {
  Dialog,
  FormControl,
  FormHelperText,
  LinearProgress,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { useForm } from "react-hook-form";
import { StyledButton } from "../../../common/components/Button";
import { StyledLabel } from "../../../common/components/InputLabel";
import LargeDropzone from "../../../common/components/LargeDropzone";
import { DialogHeader } from "../styles";
import * as yup from "yup";
import { useState } from "react";
import { rejectCaseDesign } from "../../../api/caseApi";
import { useFieldArray } from "react-hook-form";
const RejectDesignDialog = ({ caseId, open, onClose }) => {
  const [isSubmitting, setSubmitting] = useState(false);
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    watch,
    setValue,
    reset,
    trigger,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        files: yup.array().of(yup.mixed()).nullable(),
        note: yup.string().required("Note is required."),
      })
    ),
  });

  const { remove, append } = useFieldArray({
    control,
    name: "files",
  });
  const files = watch("files");

  const handleRemoveFile = (index) => {
    remove(index);
  };

  const handleDrop = (files) => {
    if (isSubmitting) return;
    files.map((file) =>
      append({
        file: file,
        type: 5,
        subType: 0,
      })
    );
    trigger("files");
  };

  const handleReject = async (values) => {
    setSubmitting(true);
    try {
      const formData = new FormData();

      formData.append("note", values.note);

      values.files &&
        values.files.forEach((fileDetails) => {
          formData.append("files", fileDetails.file);
        });

      await rejectCaseDesign(caseId, formData);
      reset();

      onClose();
    } catch (err) {
      console.log(err);
    }
    setSubmitting(false);
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
      {isSubmitting && <LinearProgress />}
      <Box
        component="form"
        sx={{ paddingX: 3, paddingY: 2 }}
        onSubmit={handleSubmit(handleReject)}
      >
        <DialogHeader>You want to reject this case?</DialogHeader>
        <Box sx={{ marginTop: 4 }}>
          <FormControl error={Boolean(errors.note)} fullWidth>
            <StyledLabel id="reject-note-label">Note</StyledLabel>
            <TextField
              aria-labelledby="reject-note-label"
              fullWidth
              multiline
              rows={6}
              name="chiefRequest"
              FormHelperTextProps={{
                variant: "standard",
              }}
              error={Boolean(errors.note)}
              {...register("note")}
              disabled={isSubmitting}
            />
            <FormHelperText>
              {Boolean(errors.note) && errors.note.message}
            </FormHelperText>
          </FormControl>
        </Box>

        <Box sx={{ marginTop: 2 }}>
          <StyledLabel error={Boolean(errors.files)} sx={{ display: "block" }}>
            Upload Files
          </StyledLabel>
          <LargeDropzone
            onDrop={handleDrop}
            current={files}
            handleRemoveFile={handleRemoveFile}
          />
          <FormHelperText error={Boolean(errors.files)} variant="filled">
            {Boolean(errors.files) && errors.files.message}
          </FormHelperText>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 4,
          }}
        >
          <StyledButton theme="green" type="submit" disabled={isSubmitting}>
            Yes
          </StyledButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default RejectDesignDialog;
